import DayOfWeek from '@cobliteam/api-lib/src/dashboard/alerts/definitions/dates';

enum DateOption {
  EVERYDAY = 'EVERYDAY',
  WEEKDAYS = 'WEEKDAYS',
  WEEKENDS = 'WEEKENDS',
}

const dateOptions = {
  [DateOption.EVERYDAY]: [DayOfWeek.SUNDAY, DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY, DayOfWeek.THURSDAY, DayOfWeek.FRIDAY, DayOfWeek.SATURDAY],
  [DateOption.WEEKDAYS]: [DayOfWeek.MONDAY, DayOfWeek.TUESDAY, DayOfWeek.WEDNESDAY, DayOfWeek.THURSDAY, DayOfWeek.FRIDAY],
  [DateOption.WEEKENDS]: [DayOfWeek.SUNDAY, DayOfWeek.SATURDAY],
};

const mapDaysOfWeekToDateOption = (daysOfWeek: DayOfWeek[]): DateOption => {
  if (daysOfWeek.length === 7) {
    return DateOption.EVERYDAY;
  }

  if (daysOfWeek.length === 5) {
    return DateOption.WEEKDAYS;
  }

  return DateOption.WEEKENDS;
};

export { DateOption, dateOptions, mapDaysOfWeekToDateOption };
